import './_style.scss'
import {mapState} from 'ui.vue3.pinia';

export const Notification = {
    props: {
        className: {
            data: String,
            default: '',
        },
        type: {
            data: String,
            default: 'default', // default, success, danger, warning
        },
        id: {
            data: String,
            default: '',
        },
        title: {
            data: String,
            default: '',
        },
        description: {
            data: String,
            default: '',
        },
        closeBtnText: {
            data: String,
            default: '',
        },
        closeBtnHandler: {
            data: Function,
            default: () => {
            }
        },
        actionBtnText: {
            data: String,
            default: '',
        },
        actionBtnHandler: {
            data: Function,
            default: () => {
            }
        },
    },
    computed: {
        ...mapState(useGlobalStorage, ['notifications']),
        typeCls: (vm) => `-${vm.$props.type}`,
    },
    template: `
      <div class="notification" :class="typeCls">
      <div class="notification__icon"></div>
      <div class="notification__body">
        <h5 class="notification__title" v-if="title.length">{{ title }}</h5>
        <button class="notification__close"
                @click="() => {closeBtnHandler(); notifications.removeNotification(id)}" type="button">
          {{ closeBtnText }}
        </button>
        <p class="notification__description" v-if="description.length" v-html="description"/>
      </div>
      <div class="notification__footer" v-if="actionBtnText.length">
        <button v-if="actionBtnText.length" class="btn-link"
                @click="() => {actionBtnHandler(); notifications.removeNotification(id)}" type="button">
          {{ actionBtnText }}
        </button>
      </div>
      </div>
    `
};